module.exports = __webpack_public_path__ + "img/search.b4dea23b.svg";